var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9202 5.25C14.0024 5.25 15.9037 6.40704 17.1423 8.06791L15.4531 7.51754C15.0593 7.38922 14.636 7.60446 14.5077 7.9983C14.3793 8.39213 14.5946 8.81542 14.9884 8.94374L18.567 10.1097C18.7954 10.1841 19.0456 10.1446 19.24 10.0035C19.4344 9.86236 19.5494 9.63665 19.5493 9.39643L19.5483 5.24982C19.5482 4.83561 19.2124 4.4999 18.7982 4.5C18.3839 4.5001 18.0482 4.83596 18.0483 5.25018L18.0487 6.79787C16.5669 5.01137 14.3896 3.75 11.9202 3.75C7.40036 3.75 3.75 7.45124 3.75 12C3.75 16.5488 7.40036 20.25 11.9202 20.25C13.8786 20.25 15.6772 19.5532 17.0836 18.3939C17.4032 18.1304 17.4488 17.6577 17.1853 17.3381C16.9218 17.0185 16.4491 16.9729 16.1295 17.2364C14.9806 18.1835 13.5163 18.75 11.9202 18.75C8.24388 18.75 5.25 15.7355 5.25 12C5.25 8.26449 8.24388 5.25 11.9202 5.25ZM18.75 16.5C19.1642 16.5 19.5 16.1642 19.5 15.75C19.5 15.3358 19.1642 15 18.75 15C18.3358 15 18 15.3358 18 15.75C18 16.1642 18.3358 16.5 18.75 16.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.7b4c0ee7.svg";
export { ForwardRef as ReactComponent };